export default (theme) => ({
  paper: {
    minHeight: 600,
    height: "70vh",
  },
});
